import ApiBaseService from "services/ApiBaseService.js";

class PatientFormService {
  // Patient-side APIs (without hospital ID)
  static getIntakePacks(patientId) {
    return ApiBaseService.request(
      `patients/${patientId}/intake`,
      "GET"
    );
  }

  static getIntakeForms([patientId, intakeId]) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms`,
      "GET"
    );
  }

  static getIntakeFormById(patientId, intakeId, formId) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms/${formId}`,
      "GET"
    );
  }

  static saveIntakeForm(patientId, intakeId, formId, formData) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms/${formId}`,
      "PUT",
      { formData }
    );
  }

  static submitIntakeForm(patientId, intakeId, formId) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms/${formId}`,
      "POST"
    );
  }

  static revokeIntakeFormSubmission(patientId, intakeId, formId) {
    return ApiBaseService.request(
      `patients/${patientId}/intake/${intakeId}/forms/${formId}/revoke`,
      "POST"
    );
  }

  static getStimReports(patientId) {
    return ApiBaseService.request(
      `patients/${patientId}/stim-reports`,
      "GET"
    );
  }

  static getStimReportData(patientId, formId) {
    return ApiBaseService.request(
      `patients/${patientId}/stim-reports/${formId}/stim-report-data`,
      "GET"
    );
  }

  static getAssessmentReports(patientId) {
    return ApiBaseService.request(
      `patients/${patientId}/assessment-reports`,
      "GET"
    );
  }

  static getAssessmentProgressReportData(patientId) {
    return ApiBaseService.request(
      `patients/${patientId}/assessment-reports/progress-report-data`,
      "GET"
    );
  }
}

export default PatientFormService;
